import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "loading-div"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "loading-text"
}, "数据初始化中...", -1);
import { useIndexStore } from '../store';
import { onBeforeUnmount, onDeactivated, onMounted, ref, watch } from 'vue';
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
import { isWebClip } from '@/utils';
export default {
  __name: 'index',
  setup(__props) {
    const userIndex = useIndexStore();
    const {
      config,
      notice,
      categoryList,
      allAdsList,
      allVideoList
    } = storeToRefs(userIndex);
    const {
      fetchConfig,
      fetchAnnouncement,
      fetchClassificationList,
      fetchAllAd,
      fetchReportInstall,
      fetchReportIp
    } = userIndex;
    const route = useRoute();
    const router = useRouter();
    const active = ref('home');
    const loading = ref(false);
    const tabbarList = [{
      name: 'home',
      icon: 'wap-home-o',
      title: '首页'
    }, {
      name: 'baoliao',
      icon: 'chat-o',
      title: '爆料'
    }, {
      name: 'qiugua',
      icon: 'question-o',
      title: '求料'
    }, {
      name: 'welfare',
      icon: 'point-gift-o',
      title: '福利'
    }];
    const showTabbar = ref(true);

    // 创建浏览器指纹
    const createFingerprint = () => {
      // 选择哪些信息作为浏览器指纹生成的依据
      const options = {
        fonts: {
          extendedJsFonts: true
        },
        excludes: {
          audio: true,
          userAgent: true,
          enumerateDevices: true,
          touchSupport: true
        }
      };
      // 浏览器指纹
      Fingerprint2.get(options, components => {
        // 参数只有回调函数或者options为{}时，默认浏览器指纹依据所有配置信息进行生成
        const values = components.map(component => component.value); // 配置的值的数组
        const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
        localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
        reportByFingerprint();
      });
    };

    // 通过浏览器指纹上报的接口
    const reportByFingerprint = () => {
      fetchAllAd();
      if (isWebClip()) {
        fetchReportInstall();
        fetchConfig({
          platform: 'h5',
          imei: localStorage.getItem('browserId'),
          device: localStorage.getItem('browserId')
        });
      } else {
        fetchConfig();
      }
    };
    watch(() => router, () => {
      active.value = route.path.replace('/', '');
      // showTabbar.value = tabbarList.find((v) => v.name === active.value)
      //     ? true
      //     : false
    }, {
      deep: true,
      immediate: true
    });

    // 汇报ip，统计
    // const browseTime = ref(0);  // 浏览时长初始值为 0
    // const clearTimeSet = ref(null);
    // const setTime = () => {
    //     //设置定时器
    //     clearTimeSet.value = setInterval(() => {
    //         browseTime.value++;
    //         console.log(browseTime.value, "时长累计");
    //     }, 1000);
    // }
    // setTime()
    // const handleBeforeUnload = () => {
    //     alert('ok')
    //     console.log('页面离开，上报统计，停留时间 ：', browseTime.value);
    //     clearInterval(clearTimeSet.value);
    //     fetchReportIp(browseTime.value);//停留时间上报。
    // }
    // window.addEventListener('beforeunload', handleBeforeUnload);

    // 汇报ip，统计
    fetchReportIp();
    //每10秒上报一次
    const fetchReportIp_loop = () => {
      setTimeout(() => {
        fetchReportIp(10);
        fetchReportIp_loop();
      }, 1000 * 10);
    };
    fetchReportIp_loop();
    onMounted(() => {
      try {
        ;
        [notice.value.length, categoryList.value.length, allAdsList.value.length, allVideoList.value.home.length].find(v => !v);
      } catch {
        loading.value = true;
      }
      Promise.all([fetchAnnouncement(), createFingerprint()]).then(() => {
        loading.value = false;
      });
    });
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_component_RouterView, {
        key: 0
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _ctx.$route.path
        }))], 1024))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_RouterView, {
        key: 1
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _ctx.$route.path
        }))]),
        _: 1
      })), showTabbar.value ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 2,
        id: "tabbarList",
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        placeholder: "",
        border: false,
        "active-color": "#ff9002",
        "inactive-color": "#c8c9cc",
        router: ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabbarList, item => {
          return _createVNode(_component_van_tabbar_item, {
            key: item.title,
            name: item.name,
            icon: item.icon,
            to: item.name
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["name", "icon", "to"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_van_overlay, {
        class: "loading-overlay",
        show: loading.value,
        "z-index": "1000"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_loading, {
          type: "spinner",
          color: "#ff9002"
        }), _hoisted_2])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};